import axios from 'axios';

const api = axios.create({
  //baseURL: 'https://x-11-project-backend.onrender.com/api',
  //baseURL:"https://x-11-project-backend.onrender.com/api",
  //baseURL:"http://localhost:5000/api",
  baseURL: 'https://backend.x11-sports.com/api',
  withCredentials: false, // ✅ enable cookies for session-based auth
  headers: {
    'Content-Type': 'application/json', // default header
  },
});

export default api;
